var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpText = require('./ReUpText');
var PlatformConstants = require('./constants/PlatformConstants');
var Icon = require('./wrappers/ReUpIcon');
var NumericalInput = require('./NumericalInput.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  StyleSheet,
} = ReactNative;

var CreditInput = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      addingCredit : false,
      extras : {addingCredit:false}
    }
  },

  _prefix : "Charge - ",
  getInitialState : function()
  {
    var locMan = this.props.appManager.getLocalizationManager();
    if( this.props.extras.addingCredit )
    {
      this._prefix = "Add - ";
    }
    return {
      layout : this.props.initialLayout,
      chargeText : this._prefix + locMan.localizedDollars(0)
    }
  },

  componentDidMount : function()
  {
  },

  didUpdate : function(data)
  {

  },

  isUsingCredit : function()
  {
    return typeof this.props.extras === 'undefined' || typeof this.props.extras.addingCredit === 'undefined' || !this.props.extras.addingCredit;
  },

  doTransaction: function()
  {
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var amount = this._ref_numInput.dollarsAmount();
    var extras = this.props.extras;
    var thisThing = this;
    if( this.isUsingCredit() )
    {
      appActions.setSpinnerShown(true, "Processing...");
      NetworkManager.vendorUseCredit(appManager, extras.U, amount, extras.Type, extras.H, extras.TT, extras.T, function(data)
      {
        appActions.setSpinnerShown(false);
        var newExtras = data;
        newExtras.success = true;
        newExtras.scanner = thisThing.props.extras.scanner;
        newExtras.isAddingCredit = false;
        appActions.requestFeatureName("TransactionResult", newExtras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var newExtras = data;
        newExtras.success = false;
        newExtras.scanner = thisThing.props.extras.scanner;
        newExtras.isAddingCredit = false;
        appActions.requestFeatureName("TransactionResult", newExtras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
      })
    }
    else // is adding credit
    {
      appActions.setSpinnerShown(true, "Processing...");
      NetworkManager.vendorAddCreditGC(appManager, this.props.extras.U, amount, "U", this.props.extras.H, function(data)
      {
        appActions.setSpinnerShown(false);
        var newExtras = data;
        newExtras.success = true;
        newExtras.type = "credit";
        newExtras.scanner = thisThing.props.extras.scanner;
        newExtras.isAddingCredit = true;
        appActions.requestFeatureName("TransactionResult", newExtras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        var newExtras = data;
        newExtras.success = false;
        newExtras.type = "credit";
        newExtras.scanner = thisThing.props.extras.scanner;
        newExtras.isAddingCredit = true;
        appActions.requestFeatureName("TransactionResult", newExtras);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert)
      })
    }
  },

  submitPressed: function()
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var creditString = this._ref_numInput.stringDollarValue();
    if( this.isUsingCredit() )
    {
      var msg = "CHARGE " + creditString + "?";
      appActions.showLocalizedAlert("Charge", msg, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
      },function()
      {
        appActions.hideAlert();
        thisThing.doTransaction();
      }], function(){}, false, false, 20, 18, 20)
    }
    else
    {
      var msg = "ADD " + creditString + "?";
      appActions.showLocalizedAlert("Add Credit", msg, ["NO_ALERT_BUTTON","YES_ALERT_BUTTON"], [function()
      {
        appActions.hideAlert();
      },function()
      {
        appActions.hideAlert();
        thisThing.doTransaction();
      }], function(){}, false, false, 20, 18, 20)
    }
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    var generalColor = appManager.getColorForKey("GeneralColor");
    var inputHeight = 400;
    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width-20;
    var buttonWidth = this.state.layout.width-20;
    var cancelButton = locManager.localizedStringForKey("CANCEL_BUTTON");

    return (
      <View style={[styles.container, {backgroundColor:generalColor}]}>
        <ReUpScrollView responder={this}>
          <View style={{flexDirection:'column', alignItems:'stretch'}}>

            <View style={{flex:1, flexDirection:'row'}}>
              <View style={{flex:1}} />
              <NumericalInput ref={(c) => { this._ref_numInput = c; }} isDollars={true} style={{height:inputHeight, width:inputWidth, marginTop:20}} appManager={this.props.appManager} valueChanged={(newValue,newStringValue)=>{thisThing.setState({chargeText:thisThing._prefix+newStringValue})}}>
              </NumericalInput>
              <View style={{flex:1}} />
            </View>

            <ReUpButton style={[styles.button,{margin:10, width: buttonWidth}]}
              appManager={appManager}
              text={this.state.chargeText}
              onPress={() =>
              {
                thisThing.submitPressed();
              }}
              />

            <ReUpButton isSecondary={true} style={[styles.button,{margin:10, width:buttonWidth}]}
              appManager={appManager}
              text={cancelButton}
              onPress={() =>
              {
                thisThing.props.appActions.requestPop();
                if( typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true )
                {
                  setTimeout(function()
                  {
                    thisThing.props.extras.scanner.scan();
                  },300)
                }
              }}
              />

          </View>
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    backgroundColor:'white'
  },
  actionBarSpacer: {
    height:0,//Globals.ACTION_BAR_HEIGHT,
  },
  image: {
    position: 'absolute',
  },
});


CreditInput.dataDependencies = []

module.exports = CreditInput;
